import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetDescriptionParams } from '../../../spacesPlatform/utils/actionParams';

export class SetWorkbookDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setWorkbookDescription', {
      id: id,
      description: description
    });
  }
}
